import App from "./App.svelte";
// nacitam si store pre hooky
import { hooksStore } from "./stores/hooks.store.js";
// init hooks
hooksStore.initHooksStore();
// vlozim subor na spracovanie hookov
import("./helpers/hooksFunctions");

const app = new App({
  target: document.body,
  props: {},
});

export default app;
